import { AudioManager } from "./AudioManager";
import type Phaser from "phaser";
import { DomainUtils, TextMaxWidth } from "@ravalmatic/catafractum-utils";
import { GameConstants } from "./GameConstants";
import { inferIsLandscapeLayout, viewportLayout } from "./ui/Layout";
import { PersistentDataManager } from "./PersistentDataManager";

export class GameManager {
    
    private static currentScene: Phaser.Scene;

    public static setCurrentScene(scene: Phaser.Scene): void {
        GameManager.currentScene = scene;
        AudioManager.onSceneChanged(scene, scene.sys.settings.key === "BoardScene");
    }

    public static init(): void {
        if (!DomainUtils.areValidDomains(GameConstants.VALID_DOMAINS)) {
            console.error("Euchre cannot start on this domain.");
            return;
        }
        PersistentDataManager.readGameData();
        GameManager.setGameSize();
        GameManager.currentScene.scene.start("PreloadScene");
    }

    public static setGameSize(): void {
        if (!GameManager.currentScene) return;

        const scaleManager = GameManager.currentScene.game.scale;
        const { width, height } = viewportLayout(inferIsLandscapeLayout());
        if (scaleManager.gameSize.width !== width || scaleManager.gameSize.height !== height) {
            scaleManager.setGameSize(width, height);
        } else {
            scaleManager.refresh();
        }
    }

    public static onAssetsLoaded(): void {
        AudioManager.init(GameManager.currentScene);
        TextMaxWidth.setDefaults({
            development: GameConstants.DEVELOPMENT
        });
        GameManager.enterSplashScene();
    }

    public static enterSplashScene(): void {
        GameManager.currentScene.scene.start("SplashScene");
    }

    public static enterBoardScene(): void {
        GameManager.currentScene.scene.start("BoardScene");
    }
}
